function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { fullName, getUserInitials } from "../infra/utils";
import { BusinessPartyTypeEnum } from "../store/store.model";
import { BusinessSettingsModel } from "./BusinessSettingsModel";
export let ColumnPaymentsStatus = /*#__PURE__*/function (ColumnPaymentsStatus) {
  ColumnPaymentsStatus["Enabled"] = "enabled";
  ColumnPaymentsStatus["Disabled"] = "disabled";
  return ColumnPaymentsStatus;
}({});
export let UserRole = /*#__PURE__*/function (UserRole) {
  UserRole["Member"] = "member";
  UserRole["Admin"] = "admin";
  UserRole["Owner"] = "owner";
  UserRole["Accountant"] = "accountant";
  UserRole["AnchorAdmin"] = "anchorAdmin";
  UserRole["Reviewer"] = "reviewer";
  return UserRole;
}({});
export class WorkspaceModel {
  static fromDTO(dto) {
    return new WorkspaceModel(dto);
  }
  constructor(data) {
    this.data = data;
  }
  toDTO() {
    return this.data;
  }
  toIdAndName() {
    return {
      id: this.data.id,
      name: this.data.name
    };
  }
  id() {
    return this.data.id;
  }
  name() {
    return this.data.name;
  }
  setName(name) {
    return new WorkspaceModel(_objectSpread(_objectSpread({}, this.data), {}, {
      name
    }));
  }
  logoUrl() {
    return this.data.logoUrl;
  }
  setupCompleted() {
    return this.data.setupCompleted;
  }
  isAccountant() {
    return this.data.role === UserRole.Accountant;
  }
  isAnchorAdmin() {
    return this.data.role === UserRole.AnchorAdmin;
  }
  isCustomer() {
    return this.data.type === BusinessPartyTypeEnum.Customer || this.data.type === BusinessPartyTypeEnum.MultiVendorCustomer;
  }
  isCustomerOfVendor(vendorId) {
    return this.data.type === BusinessPartyTypeEnum.Customer && this.data.customer.vendor.id === vendorId;
  }
  isVendor() {
    return this.data.type === BusinessPartyTypeEnum.Vendor;
  }
  isCompletelySetupAndDisplayable() {
    if (this.isAccountant() || this.isAnchorAdmin()) {
      return false;
    }
    return this.isCompletelySetup();
  }
  isCompletelySetup() {
    return this.isCustomer() && [UserRole.Owner, UserRole.Admin, UserRole.Member].includes(this.data.role) || this.isVendor() && this.setupCompleted();
  }
  getBusinessSwitcherItemSubtext() {
    switch (this.data.type) {
      case BusinessPartyTypeEnum.Vendor:
        return 'Service Provider account';
      case BusinessPartyTypeEnum.Customer:
        return "Client of ".concat(this.data.customer.vendor.name);
      case BusinessPartyTypeEnum.MultiVendorCustomer:
        return 'Client account';
    }
  }
  getBusinessSwitcherItemLogoUrl() {
    switch (this.data.type) {
      case BusinessPartyTypeEnum.Vendor:
        return this.data.logoUrl || '';
      case BusinessPartyTypeEnum.Customer:
        return this.data.customer.vendor.logoUrl || '';
      case BusinessPartyTypeEnum.MultiVendorCustomer:
        return '';
    }
  }
  setLogoUrl(logoUrl) {
    return new WorkspaceModel(_objectSpread(_objectSpread({}, this.data), {}, {
      logoUrl
    }));
  }
}
export class UserInfoModel {
  static fromDTO(dto) {
    return new UserInfoModel(dto);
  }
  constructor(data) {
    var _data$worksAt;
    this.data = data;
    this._businessSettings = ((_data$worksAt = data.worksAt) === null || _data$worksAt === void 0 ? void 0 : _data$worksAt.settings) && BusinessSettingsModel.fromDTO(data.worksAt.settings);
  }
  id() {
    return this.data.id;
  }
  email() {
    return this.data.email;
  }
  firstName() {
    return this.data.firstName;
  }
  lastName() {
    return this.data.lastName;
  }
  fullName() {
    return fullName(this.data.firstName || null, this.data.lastName || null);
  }
  phone() {
    return this.data.phone;
  }
  userInitials() {
    return getUserInitials({
      firstName: this.data.firstName,
      lastName: this.data.lastName,
      email: this.data.email
    });
  }
  referredByBusinessId() {
    var _this$data$referredBy;
    return (_this$data$referredBy = this.data.referredBy) === null || _this$data$referredBy === void 0 ? void 0 : _this$data$referredBy.businessId;
  }
  hasApprovedTermsOfService() {
    return this.data.hasApprovedTermsOfService;
  }
  numClientsAMonth() {
    return this.data.numClientsAMonth;
  }
  oAuthProvider() {
    return this.data.oAuthProvider;
  }
  identityTypes() {
    return this.data.identityTypes;
  }
  hasIdentity() {
    var _this$data$identityTy;
    return !!((_this$data$identityTy = this.data.identityTypes) !== null && _this$data$identityTy !== void 0 && _this$data$identityTy.length);
  }
  loggedInViaLink() {
    return this.data.identityTypes === null;
  }
  hasPassword() {
    var _this$data$identityTy2;
    return !!((_this$data$identityTy2 = this.data.identityTypes) !== null && _this$data$identityTy2 !== void 0 && _this$data$identityTy2.includes('password'));
  }
  workspaces() {
    var _this$data$workspaces;
    return (_this$data$workspaces = this.data.workspaces) === null || _this$data$workspaces === void 0 ? void 0 : _this$data$workspaces.map(WorkspaceModel.fromDTO);
  }
  hasAVendorAccount() {
    return (this.workspaces() || []).some(workspace => workspace.isVendor());
  }
  business() {
    return this.data.worksAt;
  }
  hasBusiness() {
    return !!(this.data.worksAt && this.data.worksAt.name && (this.data.worksAt.businessTypes.length || this.data.worksAt.description));
  }
  businessId() {
    var _this$data$worksAt;
    return (_this$data$worksAt = this.data.worksAt) === null || _this$data$worksAt === void 0 ? void 0 : _this$data$worksAt.id;
  }
  businessSettings() {
    return this._businessSettings;
  }
  businessName() {
    var _this$data$worksAt2;
    return (_this$data$worksAt2 = this.data.worksAt) === null || _this$data$worksAt2 === void 0 ? void 0 : _this$data$worksAt2.name;
  }
  businessLogoUrl() {
    var _this$data$worksAt3;
    return (_this$data$worksAt3 = this.data.worksAt) === null || _this$data$worksAt3 === void 0 ? void 0 : _this$data$worksAt3.logoUrl;
  }
  disabledPayments() {
    return this.data.worksAt ? this.data.worksAt.disablePayments : false;
  }

  /** Returns the role of the user in his current business. */
  role() {
    var _this$data$worksAt4;
    return (_this$data$worksAt4 = this.data.worksAt) === null || _this$data$worksAt4 === void 0 ? void 0 : _this$data$worksAt4.role;
  }
  isVendor() {
    var _this$data$worksAt5;
    return ((_this$data$worksAt5 = this.data.worksAt) === null || _this$data$worksAt5 === void 0 ? void 0 : _this$data$worksAt5.type) == BusinessPartyTypeEnum.Vendor;
  }
  isCustomer() {
    var _this$data$worksAt6, _this$data$worksAt7;
    return ((_this$data$worksAt6 = this.data.worksAt) === null || _this$data$worksAt6 === void 0 ? void 0 : _this$data$worksAt6.type) == BusinessPartyTypeEnum.Customer || ((_this$data$worksAt7 = this.data.worksAt) === null || _this$data$worksAt7 === void 0 ? void 0 : _this$data$worksAt7.type) == BusinessPartyTypeEnum.MultiVendorCustomer;
  }
  isOwner() {
    return this.role() === UserRole.Owner;
  }
  isAdmin() {
    return this.role() === UserRole.Admin;
  }
  isReviewer() {
    return this.role() === UserRole.Reviewer;
  }
  paymentsDisabled() {
    var _this$data$worksAt8;
    return !!((_this$data$worksAt8 = this.data.worksAt) !== null && _this$data$worksAt8 !== void 0 && _this$data$worksAt8.disablePayments);
  }
  columnEntityCreated() {
    return !!this.data.worksAt && this.data.worksAt.column.paymentsStatus === ColumnPaymentsStatus.Enabled;
  }
  hasColumnAccountId() {
    return !!this.data.worksAt && !!this.data.worksAt.column.accountId;
  }
  hasColumnWalletAccountId() {
    return !!this.data.worksAt && !!this.data.worksAt.column.walletAccountId;
  }
  hasColumnPayoutAccountId() {
    return !!this.data.worksAt && !!this.data.worksAt.column.payoutAccountId;
  }
  setWorksAt(worksAt) {
    return new UserInfoModel(_objectSpread(_objectSpread({}, this.data), {}, {
      worksAt
    }));
  }
  setNumClientsAMonth(numClientsAMonth) {
    return new UserInfoModel(_objectSpread(_objectSpread({}, this.data), {}, {
      numClientsAMonth
    }));
  }
  updateUserDetails(data) {
    return new UserInfoModel(_objectSpread(_objectSpread({}, this.data), data));
  }
  setBranding(branding) {
    const worksAt = this.data.worksAt ? _objectSpread(_objectSpread({}, this.data.worksAt), {}, {
      branding
    }) : undefined;
    return new UserInfoModel(_objectSpread(_objectSpread({}, this.data), {}, {
      worksAt
    }));
  }
  setWorkspaces(workspaces) {
    return new UserInfoModel(_objectSpread(_objectSpread({}, this.data), {}, {
      workspaces
    }));
  }
  setWorkspaceModels(workspaces) {
    return new UserInfoModel(_objectSpread(_objectSpread({}, this.data), {}, {
      workspaces: workspaces === null || workspaces === void 0 ? void 0 : workspaces.map(workspace => workspace.toDTO())
    }));
  }
}